import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('LastProgress').create(({ theme }) => ({
  header: {
    display: 'flex',
    height: '10vh',
    width: '100%',
    padding: '20px',
    backgroundColor: '#B0B1B81F',
    borderRadius: '12px',
  },

  usernameWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },

  user: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    gap: '16px',
  },

  meetText: {
    fontWeight: '170',
    fontSize: theme.sizes.texts.fontSize.xs,
    lineHeight: theme.sizes.texts.lineHeight.xs,

    color: theme.colors.text.secondary,
  },

  totalValueText: {
    color: theme.colors.text.primary,
  },

  username: {
    fontWeight: 450,
    fontSize: theme.sizes.texts.fontSize.l,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    color: theme.colors.text.primary,
  },

  profileCard: {
    width: '100%',
    position: 'relative',
    backgroundColor: '#B0B1B81F',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    marginBottom: '20px',

    span: {
      width: '100%',
      height: 0,
      border: '1px solid #FFFFFF17',
      margin: '10px 0',
    },

    ':after': {
      content: '""',
      position: 'absolute',
      width: '30%',
      aspectRatio: '1/1',
      left: '0px',
      zIndex: 0,
      bottom: '40px',
      filter: 'blur(50px)',
      background: 'rgba(65, 79, 105, 1)',
    },
  },

  usernameExtendedWrapper: {
    span: {
      fontFamily: 'Inter',
      fontWeight: 370,
      fontSize: theme.sizes.texts.fontSize.xs,
      lineHeight: theme.sizes.texts.lineHeight.xs,

      opacity: '0.7',
      border: 'none',
    },
  },

  totalBalance: {
    color: theme.colors.text.primary,
  },

  headerExtended: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '4px 0px',
    gap: '12px',
    width: '100%',
    zIndex: 2,
    overflow: 'hidden',
  },

  name: {
    margin: '0',
    fontFamily: 'Inter',
    fontWeight: '450',
    fontSize: theme.sizes.texts.fontSize.l,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    color: theme.colors.text.primary,
  },

  coinIcon: {
    width: '18px',
    height: '18px',
  },

  totalStats: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  leftSide: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    zIndex: 2,
    justifyContent: 'center',
    gap: '4px',
    // h3: {
    //   textTransform: 'uppercase',
    //   margin: '0',
    //   fontFamily: 'Inter',
    //   fontWeight: '470',
    //   fontStyle: 'normal',
    //   fontSize: '13px',
    //   lineHeight: theme.sizes.texts.lineHeight.xl,

    // },
    div: {
      fontFamily: 'Space Grotesk',
      fontSize: '22px',
      fontWeight: '470',
    },
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    justifyContent: 'center',
    gap: '4px',
    // h3: {
    //   textTransform: 'uppercase',
    //   margin: '0',
    //   fontFamily: 'Inter',
    //   fontWeight: '470',
    //   fontStyle: 'normal',
    //   fontSize: '13px',
    //   lineHeight: theme.sizes.texts.lineHeight.xl,

    // },
    div: {
      alignItems: 'center',
      justifyContent: 'space-between',
      display: 'flex',
      flexDirection: 'row',
      fontFamily: 'Space Grotesk',
      fontSize: '22px',
      fontWeight: '470',
      gap: '6px',
    },
  },

  title: {
    color: theme.colors.text.secondary,
    fontFamily: 'Inter',
    fontWeight: 370,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    textTransform: 'uppercase',
    margin: 0,
  },
}))
